module.exports = __webpack_public_path__ + "static/term-life-insurance-hero-mobile.2ff1d80e.webp";